var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.28571C19 6.37316 18.9854 6.46002 18.9568 6.54286L16.9922 18.0903C16.9013 18.6242 16.6199 19.1092 16.1982 19.4589C15.7764 19.8086 15.2417 20.0003 14.6892 20H9.30967C8.75732 20.0001 8.22286 19.8082 7.80137 19.4585C7.37988 19.1088 7.09869 18.624 7.00783 18.0903L5.04317 6.54286C5.01459 6.46002 5.00001 6.37316 5 6.28571C5 5.02286 8.13367 4 12 4C15.8663 4 19 5.02286 19 6.28571ZM6.4175 7.66514L8.15933 17.9017C8.20462 18.1686 8.34508 18.411 8.55571 18.586C8.76635 18.7609 9.03351 18.857 9.30967 18.8571H14.6903C14.9665 18.857 15.2336 18.7609 15.4443 18.586C15.6549 18.411 15.7954 18.1686 15.8407 17.9017L17.5825 7.66514C16.305 8.216 14.2797 8.57143 12 8.57143C9.72033 8.57143 7.695 8.216 6.4175 7.66514Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.b8c8dee3198949ba3b96ddb6fcb7ba14.svg";
export { ForwardRef as ReactComponent };